const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesRightBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "29.143 27.356 169.994 440.462",
    width: 169.994,
    height: 440.462,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 469.74,
    y1: 357.705,
    x2: 469.74,
    y2: 432.218,
    id: "gradient-2",
    gradientTransform: "matrix(0.861594, 0, 0, 0.880826, -326.095589, 87.107805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 222, 253)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "rgb(215, 250, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "rgb(255, 221, 221)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "rgb(245, 244, 213)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    style: {
      stopColor: "rgb(255, 213, 244)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(202, 255, 239)"
    }
  }))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(220, 254, 255)"
    },
    cx: 114.14,
    cy: 103.661,
    rx: 84.997,
    ry: 18.987
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(253, 255, 207)"
    },
    d: "M 105.485 32.079 L 51.154 60.924 L 50.594 104.053 L 105.765 107.694 L 105.485 32.079 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(255, 235, 213)",
      fill: "rgb(255, 242, 218)"
    },
    cx: 104.794,
    cy: 268.922,
    rx: 70.07,
    ry: 70.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(255, 255, 255)"
    },
    cx: 103.719,
    cy: 268.155,
    rx: 21.359,
    ry: 21.359
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(255, 235, 253)"
    },
    d: "M 101.276 205.573 C 100.775 203.47 75.603 211.536 74.881 213.684 C 74.728 215.679 51.732 231.738 51.373 230.456 C 41.852 238.729 38.093 254.615 39.275 257.263 C 41.456 259.316 39.61 283.092 38.313 281.871 C 35.589 291.977 46.34 307.895 50.273 308.404 C 55.641 306.807 74.732 317.48 74.331 329.437 C 79.654 336.867 99.085 339.073 103.751 335.349 C 104.899 331.251 123.117 329.932 122.31 332.324 C 121.503 334.716 111.174 292.594 111.174 292.594 C 110.587 290.832 104.538 293.912 104.025 295.344 C 102.285 296.858 95.418 294.794 94.54 293.281 C 94.42 292.123 86.171 287.579 84.229 288.745 C 82.77 289.546 77.499 283.208 77.768 280.909 C 78.607 280.007 76.824 272.85 75.018 271.973 C 73.712 269.285 73.874 262.963 76.806 261.662 C 79.573 260.89 81.466 255.025 81.892 252.589 C 82.218 250.727 84.692 247.122 88.216 247.503 C 90.502 248.909 96.294 247.48 97.289 244.066 C 100.301 241.782 104.769 242.988 104.576 244.554 L 105.448 205.119 L 101.276 205.573 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(236, 174, 255)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.907329, -0.420422, 0.420424, 0.907328, -460.846541, 207.054404)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(252, 255, 217)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.942035, 0.335515, -0.335516, 0.942035, -277.092782, -113.59972)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(217, 255, 236)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.19061, 0.981666, -0.981666, 0.19061, 243.628929, -232.989433)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(254, 255, 217)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.994522, -0.104527, 0.104528, 0.994522, -395.951336, 16.424162)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(255, 179, 179)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.705442, 0.708767, -0.708769, 0.705441, -70.553545, -268.606087)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(255, 176, 176)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.907329, -0.420422, 0.420424, 0.907328, -444.274031, 254.738853)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(208, 244, 255)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(-0.039151, 0.999233, -0.999233, -0.039151, 349.646739, -149.58611)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(239, 169, 255)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.403586, -0.914942, 0.914943, 0.403584, -370.124034, 600.601031)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(255, 249, 217)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.99828, 0.058625, -0.058624, 0.99828, -342.329234, 31.712262)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(217, 255, 250)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.04786, 0.998854, -0.998854, 0.047861, 335.331675, -156.988957)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(203, 245, 255)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.181014, -0.983481, 0.983481, 0.181012, -289.641732, 662.412251)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(217, 255, 236)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.907329, -0.420422, 0.420424, 0.907328, -423.278638, 183.228475)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(222, 255, 229)",
      fill: "rgb(200, 242, 255)"
    },
    cx: 448.012,
    cy: 261.976,
    rx: 1.725,
    ry: 6.249,
    transform: "matrix(0.58942, 0.807827, -0.807827, 0.589419, 37.910318, -300.229898)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "url(#gradient-2)"
    },
    d: "M 120.421 440.052 C 125.902 420.185 91.682 412.392 79.008 427.52 C 80.102 420.361 51.095 398.847 50.517 402.626 C 48.662 402.247 54.681 424.172 58.633 424.98 C 57.861 421.723 35.848 420.129 36.437 422.61 C 34.114 425.308 54.106 440.132 55.487 438.528 C 53.309 435.984 35.773 444.381 37.43 446.318 C 36.641 449.626 72.174 453.372 73.211 449.027 C 88.488 479.697 117.439 463.591 117.439 463.591 L 120.421 440.052 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(252, 225, 255)"
    },
    d: "M 110.18 28.88 C 109.635 24.75 95.039 29.584 95.956 36.528 C 90.694 33.755 81.218 39.707 81.427 44.175 C 76.822 42.106 66.932 46.339 66.897 51.669 C 62.503 49.522 54.54 54.242 54.355 58.552 C 50.388 57.877 44.887 61.112 45.024 64.058 C 46.172 68.782 58.42 68.46 59.708 64.364 C 63.515 69.153 74.691 68.872 78.061 64.364 C 81.529 68.563 92.288 68.935 95.192 64.517 C 98.356 71.206 112.557 71.219 112.321 64.823 L 110.18 28.88 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesRightBackground);
export default __webpack_public_path__ + "static/media/SalesRightBackground.51404992aa91e15b1880168601dca9a4.svg";
export { ForwardRef as ReactComponent };